import React, { useState } from 'react';
import { SubscriptionUpdatePaymentModal } from '@nexus/fff-payments';
import { useUserContext } from '@nexus/fff-utilities';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import NotFoundError from '../NotFoundError';
import Layout from '../../components/Layout';
import DesktopCards from './DesktopCards';
import MobileTable from './MobileTable';
import Notice from './Notice';
import Customize from './Customize';
import UpgradeButton from './UpgradeButton';
import CouponSelector from './CouponSelector';
import { ShowErrorOrRedirectThankYouPage } from '../../services/subscription';
import { Plans } from '../constants';
import useLaunchDarkly from '../../hooks/useLaunchDarkly';
import './styles.css';

const Upgrade = ({
  history, flags, ldClient, location: { pathname },
}) => {
  const [couponsApplied] = useState([{ message: 'Promo code FFFFREEGIFT applied!' }]);
  const [couponError, setCouponError] = useState({});
  const { userInfo } = useUserContext();
  useLaunchDarkly(ldClient, userInfo);

  const isSeasonal = userInfo && userInfo.user && userInfo.user.subscriptionType === 'SEASONAL';
  const thanksPage = pathname && pathname.indexOf('/my-account-v3/') === -1
    ? '/upgrade-thanks'
    : '/my-account-v3/upgrade-thanks';

  if (!isSeasonal) {
    window.location.replace(process.env.REACT_APP_SITE_URL);
    return null;
  }

  const {
    showUpdatePayment,
    errorPaymentMessage,
    changeSubscription,
    onClose,
    isLoading,
  } = ShowErrorOrRedirectThankYouPage(history, thanksPage, Plans.SEASONAL);

  const handleApplyCoupon = (code) => {
    if (code) {
      setCouponError({ message: 'This promo code is invalid', type: 'invalid' });
    } else {
      setCouponError({ message: 'The promo code is empty', type: 'empty' });
    }
  };

  if (flags && flags.newUpgrade === false) {
    return <NotFoundError />;
  }

  if (flags && flags.newUpgrade) {
    return (
      <Layout isLoading={isLoading}>
        <div id="content" className="site-content">
          <div className="upgrade-background-banner">
            <img
              className="mobile-hidden background-banner-wave"
              src="https://s3-us-west-2.amazonaws.com/abtesting-assets/upgrade_10202020/images/white-wave.svg"
              alt="background"
            />
          </div>
          <div className="upgrade-row upgrade-container" style={{ position: 'relative' }}>
            <div className="upgrade-col padding-none">
              <div className="page-content">
                <article className="page">
                  <div className="upgrade-confirmation-container">
                    <div className="head text-center">Upgrade Now</div>
                    <div className="sub-head text-center">Upgrade to an Annual Membership Today!</div>
                    <DesktopCards />
                    <MobileTable />
                    <CouponSelector
                      onApplyCoupon={handleApplyCoupon}
                      error={couponError}
                      couponsApplied={couponsApplied}
                      isInitialyOpen={false}
                    />
                    <div className="acceptance-container">
                      <Notice />
                      <UpgradeButton onClickUpgrade={() => changeSubscription(Plans.ANNUAL)} />
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
          <hr className="upgrade-divider" />
          <Customize onClickUpgrade={() => changeSubscription(Plans.ANNUAL)} />
        </div>
        <SubscriptionUpdatePaymentModal
          onClose={onClose}
          subtitle={errorPaymentMessage}
          isOpen={showUpdatePayment}
          onSuccess={() => changeSubscription(Plans.ANNUAL)}
        />
      </Layout>
    );
  }

  return null;
};

export default withLDConsumer()(Upgrade);
